import { useState } from 'react';

export function useTableSelection<TIdentifier>() {
    const [selection, setSelection] = useState(new Set<TIdentifier>());

    function isSelected(id: TIdentifier) {
        return selection.has(id);
    }

    function select(id: TIdentifier) {
        setSelection((previousValue) => {
            return new Set([...previousValue, id]);
        });
    }

    function deselect(id: TIdentifier) {
        setSelection((previousValue) => {
            const newSelection = new Set(previousValue);
            newSelection.delete(id);

            return newSelection;
        });
    }

    function toggle(id: TIdentifier) {
        if (isSelected(id)) {
            deselect(id);
        } else {
            select(id);
        }
    }

    function clear() {
        setSelection(new Set());
    }

    function getSelected() {
        return Array.from(selection);
    }

    function getSize() {
        return selection.size;
    }

    function hasSelected() {
        return selection.size > 0;
    }

    return {
        clear,
        deselect,
        getSelected,
        getSize,
        hasSelected,
        isSelected,
        select,
        toggle,
    };
}
